/* eslint-disable react/destructuring-assignment */
/* eslint-disable react/display-name */
/* eslint-disable no-nested-ternary */
/* eslint-disable react/no-array-index-key */
/* eslint-disable react/jsx-key */
import React, { useEffect, useState } from "react";
import { useTable, usePagination, useSortBy } from "react-table";
import {
  Button,
  Card,
  CardBody,
  CardTitle,
  Col,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Form,
  FormGroup,
  Input,
  Label,
  Row,
  UncontrolledDropdown,
} from "reactstrap"; //
import DatatablePagination from "components/DatatablePagination";
import AppLayout from "layout/AppLayout";
import axios from "axiosClient";
import { useToken } from "auth/useToken";
import { Link, NavLink, useNavigate } from "react-router-dom";
import SelectInput from "components/common/SelectInput";
import moment from "moment";
import DatePicker from "react-datepicker";
import { useUser } from "auth/useUser";

import "react-datepicker/dist/react-datepicker.css";
import { currencyFormatter } from "utils/formatter";
import ListingTable2 from "components/ListingTable2";
import { toast } from "react-toastify";
import ReceiptUploadModal from "components/payments/ReceiptUploadModal";
import LoadError from "components/LoadError";
import PaymentsImportModal from "components/payments/PaymentsImportModal";

function Table({ columns, data, total }) {
  const {
    getTableProps,
    getTableBodyProps,
    prepareRow,
    headerGroups,
    page,
    canPreviousPage,
    canNextPage,
    pageCount,
    gotoPage,
    setPageSize,
    state: { pageIndex, pageSize },
  } = useTable(
    {
      columns,
      data,
      initialState: { pageIndex: 0, pageSize: 20 },
    },
    useSortBy,
    usePagination,
  );

  return (
    <>
      <table {...getTableProps()} className="r-table table text-left">
        <thead>
          {headerGroups.map((headerGroup) => (
            <tr {...headerGroup.getHeaderGroupProps()}>
              {headerGroup.headers.map((column, columnIndex) => (
                <th key={`th_${columnIndex}`}>
                  {column.render("Header")}
                  <span />
                </th>
              ))}
            </tr>
          ))}
        </thead>
        <tbody {...getTableBodyProps()}>
          {page.map((row) => {
            prepareRow(row);
            return (
              <tr {...row.getRowProps()}>
                {row.cells.map((cell, cellIndex) => (
                  <td
                    key={`td_${cellIndex}`}
                    {...cell.getCellProps({
                      className: cell.column.cellClass,
                    })}
                  >
                    {cell.render("Cell")}
                  </td>
                ))}
              </tr>
            );
          })}
        </tbody>
      </table>

      <DatatablePagination
        page={pageIndex}
        pages={pageCount}
        canPrevious={canPreviousPage}
        canNext={canNextPage}
        pageSizeOptions={[4, 10, 20, 30, 40, 50]}
        showPageSizeOptions={false}
        showPageJump={false}
        defaultPageSize={pageSize}
        onPageChange={(p) => gotoPage(p)}
        onPageSizeChange={(s) => setPageSize(s)}
        paginationMaxSize={pageCount}
      />
      <p>
        {total} {total === 1 ? "payment" : "payments"}
      </p>
    </>
  );
}

// Whether Smartup took the payment. Payments taken before the outcome was
// recorded per payment carry no status, only the older `smartupImported` flag.
const SMARTUP_BADGES = {
  sent: { color: "success", label: "Sent" },
  failed: { color: "danger", label: "Failed" },
  skipped: { color: "secondary", label: "Skipped" },
};

export const smartupState = (payment) =>
  payment?.smartupStatus || (payment?.smartupImported ? "sent" : "");

const SmartupBadge = ({ payment }) => {
  const state = smartupState(payment);
  if (!state) return <span className="text-muted">—</span>;
  const meta = SMARTUP_BADGES[state] || { color: "secondary", label: state };
  return (
    <span
      className={`badge badge-${meta.color} text-white`}
      title={payment?.smartupError || ""}
    >
      {meta.label}
    </span>
  );
};

const customCols = [
  {
    Header: "ID",
    accessor: "enquiryId",
    cellClass: "text-muted w-10",
    Cell: (props) => (
      <>
        <NavLink to={`/app/payments/enquiry/${props.row.original._id}`}>
          {props.value}
        </NavLink>
      </>
    ),
    sortType: "basic",
  },
  {
    Header: "Smartup ID",
    accessor: "smartupId",
    cellClass: "text-muted w-10",
    Cell: (props) => <>{props.value}</>,
    sortType: "basic",
  },
  {
    Header: "Smartup",
    accessor: "smartupStatus",
    cellClass: "text-muted w-8",
    Cell: (props) => <SmartupBadge payment={props.row.original} />,
    sortType: "basic",
  },
  {
    Header: "Passport No",
    accessor: "candidatePassport",
    cellClass: "text-muted w-10",
    Cell: (props) => <>{props.value}</>,
    sortType: "basic",
  },
  {
    Header: "PINPP",
    accessor: "pinpp",
    cellClass: "text-muted w-10",
    Cell: (props) => <>{props.value}</>,
    sortType: "basic",
  },
  {
    Header: "Candidate",
    accessor: "candidateName",
    cellClass: "text-muted w-20",
    Cell: (props) => (
      <>
        <NavLink to={`/app/payments/enquiry/${props.row.original._id}`}>
          {`${props.row.original.firstName} ${props.row.original.lastName}`}
        </NavLink>
      </>
    ),
    sortType: "basic",
  },
  {
    Header: "Exam",
    accessor: "exam",
    cellClass: "text-muted w-8",
    Cell: (props) => <>{props.value}</>,
    sortType: "basic",
  },
  {
    Header: "Module",
    accessor: "module",
    cellClass: "text-muted w-10",
    Cell: (props) => <>{props.value}</>,
    sortType: "basic",
  },
  {
    Header: "Exam Date",
    accessor: "examDate",
    cellClass: "text-muted w-8",
    Cell: (props) => <>{props.value}</>,
    sortType: "basic",
  },
  {
    Header: "Transaction ID",
    accessor: "transactionId",
    cellClass: "text-muted w-10",
    Cell: (props) => <>{props.value}</>,
    sortType: "basic",
  },
  {
    Header: "Created At",
    accessor: "createdAt",
    cellClass: "text-muted w-10",
    Cell: (props) => <>{moment(props.value).format("DD/MM/YYYY")}</>,
    sortType: "basic",
  },
  {
    Header: "Amount",
    accessor: "amount",
    cellClass: "text-muted w-10 money-cell",
    headerClassName: "money-cell",
    Cell: (props) => <>{currencyFormatter(props.value, "")}</>,
    sortType: "basic",
  },
  {
    Header: "Payment Method",
    accessor: "paymentMethod",
    cellClass: "text-muted w-10",
    Cell: (props) => <>{props.value}</>,
    sortType: "basic",
  },
];

const PaymentsList = () => {
  const user = useUser();
  const cols = React.useMemo(
    () =>
      user.role === "Admin" || user.role === "Manager"
        ? [
            ...customCols,
            {
              Header: "Editor",
              accessor: "editor",
              cellClass: "text-muted w-10",
              Cell: (props) => <>{props.value}</>,
              sortType: "basic",
            },
          ]
        : [...customCols],
    [],
  );
  const navigate = useNavigate();

  const [token, setToken] = useToken();
  const [enquiriesList, setEnquiriesList] = useState([]);
  const [enquiriesTotal, setEnquiriesTotal] = useState(0);
  const [searchValues, setSearchValues] = useState({});
  const [showData, setShowData] = useState(false);
  const [modules, setModules] = useState([]);
  const [sessions, setSessions] = useState([]);
  const [methods, setMethods] = useState([]);
  const [exams, setExams] = useState([]);
  const [refresh, setRefresh] = useState(true);
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPage, setTotalPage] = useState(1);
  const [selectedPageSize, setSelectedPageSize] = useState(30);
  const [showReceiptModal, setShowReceiptModal] = useState(false);
  const [showImportModal, setShowImportModal] = useState(false);
  // filter options failed to load, so the page cannot be shown yet
  const [optionsError, setOptionsError] = useState("");
  const [searchError, setSearchError] = useState("");

  const [isUser, setIsUser] = useState(
    user.role === "User" ? true : user.role === "Consultant" ? true : false,
  );

  useEffect(() => {
    let isMounted = true;
    setOptionsError("");
    axios
      .get("/api/payments-search-distinct", {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((result) => {
        if (isMounted) {
          let tempMethods = [];
          result.data[0].distinctMethod.forEach((method) =>
            tempMethods.push({ label: method, value: method }),
          );
          setMethods(tempMethods);

          let tempModules = [];
          result.data[0].distinctModule.forEach((module) =>
            tempModules.push({ label: module, value: module }),
          );
          setModules(tempModules);

          let tempSessions = [];
          result.data[0].distinctSession.forEach((session) =>
            tempSessions.push({ label: session, value: session }),
          );
          setSessions(tempSessions);

          let tempExams = [];
          result.data[0].distinctExam.forEach((exam) =>
            tempExams.push({ label: exam, value: exam }),
          );
          setExams(tempExams);
          if (user.role !== "Admin") {
            setSearchValues({
              ...searchValues,
              from: moment().subtract(
                user?.searchPeriod
                  ? user?.searchPeriod === 1
                    ? 0
                    : user?.searchPeriod
                  : 0,
                "days",
              ),
              to: moment(),
            });
          }
          setShowData(true);
        }
      })
      .catch(() => {
        if (isMounted) {
          const message =
            "Could not load the search filters. Check your connection and try again.";
          setOptionsError(message);
          setLoading(false);
          toast.error(message);
        }
      });
    return () => {
      isMounted = false;
    };
  }, [refresh]);

  const handleSearchValueChange = (e) => {
    setSearchValues({ ...searchValues, [e.target.name]: e.target.value });
  };


  const handleSearchSubmit = (
    currentPage = 1,
    selectedPageSize = 30,
    searchValues,
  ) => {
    setLoading(true);
    setSearchError("");
    axios
      .post(
        "/api/payments",
        { page: currentPage, per_page: selectedPageSize, ...searchValues },
        {
          headers: { Authorization: `Bearer ${token}` },
        },
      )
      .then((result) => {
        setEnquiriesList(result.data.enquiries);
        setEnquiriesTotal(result.data.total);
        setShowData(true);
        setCurrentPage(result.data.page);
        setTotalPage(result.data.pageCount);
      })
      .catch(() => {
        const message =
          "Could not load payments. Check your connection and try again.";
        setSearchError(message);
        toast.error(message);
      })
      .finally(() => setLoading(false));
  };

  const handleUpdatePinfl = () => {
    // console.log();
    setLoading(true);
    axios
      .post("/api/update-pinfl-payments", searchValues, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((result) => {
        // console.log(result.data);
        toast.success(result.data.msg);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const handleDownload = () => {
    axios
      .post("/api/payments-download", searchValues, {
        responseType: "blob",
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((result) => {
        // FileDownload(result.data, "enquiries.xlsx");
        // window.saveAs(new Blob([result.data]), "enquiries.xlsx");
        const url = window.URL.createObjectURL(new Blob([result.data]));
        const link = document.createElement("a");
        link.href = url;
        link.download = "payments.xlsx"; //or any other extension
        document.body.appendChild(link);
        link.click();
      });
  };

  const handleDownloadReport = () => {
    axios
      .post("/api/payments-report-download", searchValues, {
        responseType: "blob",
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((result) => {
        const url = window.URL.createObjectURL(new Blob([result.data]));
        const link = document.createElement("a");
        link.href = url;
        link.download = `Payments-${moment().format("DD-MM-YYYY")}.pdf`; //or any other extension
        document.body.appendChild(link);
        link.click();
      });
  };

  const handleDownloadImportTemplate = () => {
    axios
      .get("/api/payments-import-template", {
        responseType: "blob",
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((result) => {
        const url = window.URL.createObjectURL(new Blob([result.data]));
        const link = document.createElement("a");
        link.href = url;
        link.download = "PaymentsImportTemplate.xlsx";
        document.body.appendChild(link);
        link.click();
      })
      .catch((error) => {
        console.error(error);
        toast.error("Unable to download import template.");
      });
  };

  return (
    <AppLayout>
      <div className="dashboard-wrapper">
        <Card className="h-100 m-4">
          <CardBody>
            <CardTitle>Payments</CardTitle>
            <Form
              onSubmit={(e) => {
                e.preventDefault();
                if (loading) return;

                handleSearchSubmit(1, selectedPageSize, searchValues);
              }}
            >
              <Row className="text-left">
                <Col md="2">
                  <FormGroup>
                    <Label>First Name</Label>
                    <Input
                      type="text"
                      name="firstName"
                      value={searchValues.firstName}
                      onChange={handleSearchValueChange}
                    />
                  </FormGroup>
                </Col>
                <Col md="2">
                  <FormGroup>
                    <Label>Last Name</Label>
                    <Input
                      type="text"
                      name="lastName"
                      value={searchValues.lastName}
                      onChange={handleSearchValueChange}
                    />
                  </FormGroup>
                </Col>
                <Col md="2">
                  <FormGroup>
                    <Label>Passport</Label>
                    <Input
                      type="text"
                      name="candidatePassport"
                      value={searchValues.candidatePassport}
                      onChange={handleSearchValueChange}
                    />
                  </FormGroup>
                </Col>
                <Col md="2">
                  <FormGroup>
                    <Label>Smartup ID</Label>
                    <Input
                      type="text"
                      name="smartupId"
                      value={searchValues.smartupId}
                      onChange={handleSearchValueChange}
                    />
                  </FormGroup>
                </Col>
                <Col md="2">
                  <FormGroup>
                    <Label for="smartupState">Smartup</Label>
                    <SelectInput
                      inputId="smartupState"
                      name="smartupState"
                      value={searchValues.smartupState || ""}
                      onChange={(value) =>
                        setSearchValues((prev) => ({
                          ...prev,
                          smartupState: value,
                        }))
                      }
                      options={[
                        { label: "All", value: "" },
                        { label: "Failed", value: "failed" },
                        { label: "Sent", value: "sent" },
                        { label: "No record", value: "notSent" },
                      ]}
                    />
                  </FormGroup>
                </Col>
                <Col md="2">
                  <FormGroup>
                    <Label for="paymentMethodFilter">Payment Method</Label>
                    <SelectInput
                      inputId="paymentMethodFilter"
                      value={searchValues.paymentMethod || []}
                      options={methods}
                      onChange={(value) =>
                        setSearchValues((prev) => ({ ...prev, paymentMethod: value }))
                      }
                      placeholder="All"
                      isMulti
                    />
                  </FormGroup>
                </Col>
                <Col md="2">
                  <FormGroup>
                    <Label for="examFilter">Exam</Label>
                    <SelectInput
                      inputId="examFilter"
                      value={searchValues.exam || []}
                      options={exams}
                      onChange={(value) =>
                        setSearchValues((prev) => ({ ...prev, exam: value }))
                      }
                      placeholder="All"
                      isMulti
                    />
                  </FormGroup>
                </Col>
                <Col md="3">
                  <FormGroup>
                    <Label for="moduleFilter">Module</Label>
                    <SelectInput
                      inputId="moduleFilter"
                      value={searchValues.module || []}
                      options={modules}
                      onChange={(value) =>
                        setSearchValues((prev) => ({ ...prev, module: value }))
                      }
                      placeholder="All"
                      isMulti
                    />
                  </FormGroup>
                </Col>
                <Col md="3">
                  <FormGroup>
                    <Label for="sessionFilter">Session</Label>
                    <SelectInput
                      inputId="sessionFilter"
                      value={searchValues.examDate || []}
                      options={sessions}
                      onChange={(value) =>
                        setSearchValues((prev) => ({ ...prev, examDate: value }))
                      }
                      placeholder="All"
                      isMulti
                    />
                  </FormGroup>
                </Col>
                {isUser ? null : (
                  <>
                    <Col md="3">
                      <FormGroup>
                        <Label>From</Label>
                        <DatePicker
                          name="from"
                          autoComplete="off"
                          selected={
                            searchValues.from
                              ? new Date(searchValues.from)
                              : null
                          }
                          dateFormat="dd/MM/yyyy"
                          placeholderText="dd/mm/yyyy"
                          onChange={(date) => {
                            setSearchValues({
                              ...searchValues,
                              from: moment(date).format("YYYY-MM-DD"),
                            });
                          }}
                        />
                      </FormGroup>
                    </Col>
                    <Col md="3">
                      <FormGroup>
                        <Label>To</Label>
                        <DatePicker
                          name="to"
                          autoComplete="off"
                          selected={
                            searchValues.to ? new Date(searchValues.to) : null
                          }
                          dateFormat="dd/MM/yyyy"
                          placeholderText="dd/mm/yyyy"
                          onChange={(date) => {
                            setSearchValues({
                              ...searchValues,
                              to: moment(date).format("YYYY-MM-DD"),
                            });
                          }}
                        />
                      </FormGroup>
                    </Col>
                  </>
                )}
                <Col md="12" className="d-flex justify-content-between">
                  <div className="row ml-2">
                    <UncontrolledDropdown>
                      <DropdownToggle caret color="light" className="mr-2">
                        Actions
                      </DropdownToggle>
                      <DropdownMenu>
                        <DropdownItem onClick={handleDownloadReport}>
                          Download Report
                        </DropdownItem>
                        {!isUser && (
                          <DropdownItem
                            onClick={() => setShowReceiptModal(true)}
                          >
                            Generate Payment Receipts XLSX
                          </DropdownItem>
                        )}
                        {!isUser && (
                          <DropdownItem onClick={handleDownloadImportTemplate}>
                            Download Import Template
                          </DropdownItem>
                        )}
                        {!isUser && (
                          <DropdownItem
                            onClick={() => setShowImportModal(true)}
                          >
                            Import Payments (XLSX)
                          </DropdownItem>
                        )}
                        {!isUser && (
                          <DropdownItem onClick={handleDownload}>
                            Download .xlsx
                          </DropdownItem>
                        )}
                        {/* {!isUser && (
                        <DropdownItem onClick={() => navigate("/app/prices")}>
                          Prices
                        </DropdownItem>
                      )} */}
                      </DropdownMenu>
                    </UncontrolledDropdown>

                    <Button
                      color="primary"
                      onClick={() => navigate("/app/payments/enquiry/add")}
                    >
                      Add New
                    </Button>
                  </div>
                  <Button
                    color="primary"
                    onClick={() =>
                      handleSearchSubmit(1, selectedPageSize, searchValues)
                    }
                    className="mr-2"
                    disabled={loading || Boolean(optionsError)}
                  >
                    {loading ? "Searching…" : "Search"}
                  </Button>
                </Col>
              </Row>
            </Form>
          </CardBody>
        </Card>
        {optionsError && (
          <LoadError
            className="mx-4"
            message={optionsError}
            onRetry={() => setRefresh(!refresh)}
          />
        )}
        {showData && (
          <ListingTable2
            columns={cols}
            data={enquiriesList}
            totalItemCount={enquiriesTotal}
            handleSearch={handleSearchSubmit}
            loading={loading}
            currentPage={currentPage}
            setCurrentPage={setCurrentPage}
            totalPage={totalPage}
            selectedPageSize={selectedPageSize}
            setSelectedPageSize={setSelectedPageSize}
            searchValues={searchValues}
            withNumeration={false}
            emptyText="No payments match these filters."
            error={searchError}
            onRetry={() =>
              handleSearchSubmit(currentPage, selectedPageSize, searchValues)
            }
          />
        )}
        {!isUser && (
          <ReceiptUploadModal
            isOpen={showReceiptModal}
            toggle={() => setShowReceiptModal(!showReceiptModal)}
          />
        )}
        {!isUser && (
          <PaymentsImportModal
            isOpen={showImportModal}
            toggle={() => setShowImportModal(!showImportModal)}
          />
        )}
      </div>
    </AppLayout>
  );
};

export default PaymentsList;
